import { motion } from "framer-motion";
import { profile, stats } from "../../data/portfolio";
import { Reveal, SectionHead } from "./Reveal";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-28 md:py-40 overflow-hidden">
      <div className="absolute rounded-full mix-blend-multiply blur-3xl opacity-40 bg-sage w-96 h-96 top-20 -right-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionHead eyebrow="Profile" title={<>A clinician's eye,<br />a researcher's rigour.</>} testid="about-heading" />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <p className="font-display text-2xl md:text-[1.7rem] font-light leading-snug text-ink/90">
                {profile.summary}
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="glass glass-hover mt-10 p-7 md:p-8" data-testid="about-objective-card">
                <p className="eyebrow mb-3">Career objective</p>
                <p className="text-base md:text-lg leading-relaxed text-ink/85 font-light">{profile.objective}</p>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-5 grid grid-cols-2 gap-5">
            {stats.map((s, i) => (
              <motion.div
                key={s.label}
                data-testid={`about-stat-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 + i * 0.1 }}
                className={`glass glass-hover p-6 md:p-7 ${i % 2 === 1 ? "mt-8" : ""}`}
              >
                <p className="font-display text-4xl md:text-5xl font-light text-ink leading-none">{s.value}</p>
                <p className="mt-3 text-xs font-medium tracking-[0.14em] uppercase text-fog leading-relaxed">{s.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
